import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Button } from "@material-ui/core";
import Launch from "@material-ui/icons/Launch";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import Add from "@material-ui/icons/Add";
import Print from "@material-ui/icons/Print";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PaymentIcon from "@material-ui/icons/Payment";
import CancelIcon from "@material-ui/icons/Cancel";
import { Modal, Descriptions, Tag } from "antd";
import { Input } from "antd";
import { PostData } from "../../../api/service";
import CertificateEditModal from "./CertificateEditModal";

const { TextArea } = Input;

export default class RequestTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      showModal: false,
      reason: "",
      showEditModal: false,
      viewModal: false,
      viewData: null
    };
  }

  onActionClick(el) {
    this.props.actionClick(el);
  }

  onViewClick(el){
    this.setState({
      viewModal: true,
      viewData: el
    })
  }

  onViewCancel() {
    this.setState({
      viewModal: false,
      viewData: null
    })
  }

  onPrintClick(el) {
    this.props.printClick(el);
  }

  onButtonClick = (id) => {
    this.props.onButtonClick(id);
  };

  onGenerateClick(el) {
    this.setState({
      id: el.id,
      showEditModal: true,
    });
  }

  onEditSubmit() {
    // submit the data and generate the certificate with certificate_sl_no
  }

  onCancel(el) {
    this.setState({
      id: el.id,
      showModal: true,
    });
  }

  onCancelSubmit(data) {
    PostData(
      `/${this.props.apikey}/${this.props.username}/cancelcertificaterequest`,
      data
    ).then((resp) => {
      Modal.info({
        title: "Message",
        content: resp,
        showIcon: true,
        onOk: () => {
          this.props.__getRequests();
        },
      });
      this.setState({
        id: "",
        showModal: false,
        reason: "",
      });
    });
  }

  render() {
    const columns = [
      {
        name: "#",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Certificate Type",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Student Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Father's Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Mother's Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Gender",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Address",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Course",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Semester",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Roll No",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Currently At",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Payment",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Verification Status",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Library Status",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Status",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Timestamp",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (el) => (
            <div>
              {el.status == 0 ? (
                <>
                  <Button
                    startIcon={<PaymentIcon />}
                    target="_blank"
                    href={`/certificate/receipt-print?certificate_request_id=${el.id}`}
                  >
                    Payment Receipt
                  </Button>

                  <Button
                    startIcon={<ViewCarouselIcon />}
                    onClick={() => this.onViewClick(el)}
                    // target="_blank"
                    // href={`/certificate/receipt-print?certificate_request_id=${el.id}`}
                  >
                    View
                  </Button>

                  <Button
                    startIcon={<Launch />}
                    onClick={this.onGenerateClick.bind(this, el)}
                  >
                    Generate
                  </Button>

                  <Button
                    startIcon={<CancelIcon />}
                    onClick={this.onCancel.bind(this, el)}
                  >
                    Cancel
                  </Button>
                </>
              ) : null}
            </div>
          ),
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      selectableRows: false,
      responsive: "scroll",
      setRowProps: (row, index) => {
        return {
          style: {
            backgroundColor: row[10] == "ADMIN" ? "#ABEBC6" : "white",
            cursor: "pointer",
          },
        };
      },
      customToolbar: () => {
        return (
          <IconButton onClick={null}>
            <Add />
          </IconButton>
        );
      },
    };

    let data = [];
    let table_data = this.props.table_data;
    if (table_data.length > 0) {
      data = table_data.map((el, index) => [
        index + 1,
        el.type_name,
        el.name,
        el.father_name,
        el.mother_name,
        el.gender,
        el.address,
        el.course,
        el.semester,
        el.roll_no,
        el.now_at,
        el.payment_status == 1
          ? `Rs. ${el.amount_paid} on ${el.amount_paid_on}`
          : `Not Paid`,
        el.verification_status == 0
          ? "Pending"
          : el.verification_status == 1
          ? `Approved on ${el.verification_status_on}`
          : "Rejected",
        el.library_status == 0
          ? "Pending"
          : el.library_status == 1
          ? `Approved on ${el.library_verification_on}`
          : "Rejected",
        el.status == 0
          ? "Pending"
          : el.status == 1
          ? "Generated"
          : `Cancelled, ${el.cancel_reason}`,
        el.time_stamp,
        el,
      ]);
    } else {
      data = [];
    }

    return (
      <div>
        <MUIDataTable
          title={"Certificate Requests"}
          data={data}
          columns={columns}
          options={options}
        />
        {this.state.showModal ? (
          <Modal
            open={this.state.showModal}
            onOk={() =>
              this.onCancelSubmit({
                id: this.state.id,
                reason: this.state.reason,
              })
            }
            onCancel={() =>
              this.setState({
                id: "",
                showModal: false,
                reason: "",
              })
            }
            okText={`SUBMIT`}
            cancelText={`CANCEL`}
            title={`Cancel Request`}
          >
            <TextArea
              rows={4}
              placeholder="Reason for cancellation"
              onChange={(e) =>
                this.setState({
                  reason: e.target.value,
                })
              }
              required
            />
          </Modal>
        ) : null}

        {this.state.showEditModal && (
          <CertificateEditModal
            certificate_request_id={this.state.id}
            reload={() => {
              this.props.reloadAllData();
            }}
            onCancel={() => {
              this.setState({
                id: "",
                showEditModal: false,
              });
            }}
          />
        )}


        {this.state.viewModal && this.state.viewData && (
        <Dialog
          open={this.state.viewModal}
          maxWidth={`lg`}
          onClose={() => this.onViewCancel()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Certificate Request"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Here are the details submitted by the student for certificate.
            </DialogContentText>

            <Descriptions column={2} bordered={true} size="small">
              <Descriptions.Item label="Certificate Type">
                {this.state.viewData.type_name}
              </Descriptions.Item>
              <Descriptions.Item label="Applied By">
                {this.state.viewData.name}
              </Descriptions.Item>
              <Descriptions.Item label="Course">
                {this.state.viewData.course}
              </Descriptions.Item>
              <Descriptions.Item label="Semester/Year">
                {this.state.viewData.semester}
              </Descriptions.Item>
              <Descriptions.Item label="Father's Name">
                {this.state.viewData.father_name}
              </Descriptions.Item>
              <Descriptions.Item label="Mother's Name">
                {this.state.viewData.mother_name}
              </Descriptions.Item>
              <Descriptions.Item label="Gender">
                {this.state.viewData.gender}
              </Descriptions.Item>
              <Descriptions.Item label="Address">
                {this.state.viewData.address}
              </Descriptions.Item>
              <Descriptions.Item label="Roll No">
                {this.state.viewData.roll_no}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {this.state.viewData.email}
              </Descriptions.Item>
              <Descriptions.Item label="Phone">
                {this.state.viewData.phone}
              </Descriptions.Item>

              <Descriptions.Item label="Do you have Library Card ?">
                {this.state.viewData.has_library_card}
              </Descriptions.Item>

              {this.state.viewData.has_library_card == "YES" && <Descriptions.Item label="Library Card ID/ User Id">
                {this.state.viewData.library_card_no}
              </Descriptions.Item>}

              {this.state.viewData.type_code == "BC" && (
                <>
                  <Descriptions.Item label="Session">
                    {this.state.viewData.session}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "CC" && (
                <>
                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                  <Descriptions.Item label="Are you still studying ?">
                    {this.state.viewData.is_studying}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "MPC" && (
                <>
                  <Descriptions.Item label="University Roll No">
                    {this.state.viewData.university_roll_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="University Registration No">
                    {this.state.viewData.registration_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="University Registration Year">
                    {this.state.viewData.registration_year}
                  </Descriptions.Item>

                  <Descriptions.Item label="Session">
                    {this.state.viewData.session}
                  </Descriptions.Item>

                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>

                  <Descriptions.Item label="Passing Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>

                  <Descriptions.Item label="Passing Month">
                    {this.state.viewData.passing_month}
                  </Descriptions.Item>

                  <Descriptions.Item label="CGPA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "TC" && (
                <>
                  <Descriptions.Item label="Are you still studying ?">
                    {this.state.viewData.is_studying}
                  </Descriptions.Item>
                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>

                  <Descriptions.Item label="CPGA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>

                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "PPC" && (
                <>
                <Descriptions.Item label="University Roll No">
                    {this.state.viewData.university_roll_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>
                  <Descriptions.Item label="CPGA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>

                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                </>
              )}

              <Descriptions.Item label="Applied on">
                {this.state.viewData.date_of_application}
              </Descriptions.Item>
              <Descriptions.Item label="Submitted On">
                {this.state.viewData.time_stamp}
              </Descriptions.Item>
              <Descriptions.Item label="Currently at">
                <strong>{this.state.viewData.now_at}</strong>
              </Descriptions.Item>

              <Descriptions.Item label="Verification Status">
              {this.state.viewData.verification_status == 1 && (
                  <Tag color="#2ECC71">Verified</Tag>
                )}
                {this.state.viewData.verification_status == 0 && (
                  <Tag color="#A569BD">Not Verified</Tag>
                )}
                {this.state.viewData.verification_status == 2 && (
                  <Tag color="#C0392B">Rejected</Tag>
                )}
                &nbsp;
                <i>{this.state.viewData.verification_remarks}</i>
              </Descriptions.Item>
              {this.state.viewData.verification_status == 1 && (
                <Descriptions.Item label="Verified On">
                  {this.state.viewData.verification_status_on} by{" "}
                  <strong>{this.state.viewData.verification_status_by}</strong>
                </Descriptions.Item>
              )}
              <Descriptions.Item label="Library Status">
              {this.state.viewData.library_status == 1 && (
                  <Tag color="#2ECC71">Verified</Tag>
                )}
                {this.state.viewData.library_status == 0 && (
                  <Tag color="#A569BD">Not Verified</Tag>
                )}
                {this.state.viewData.library_status == 2 && (
                  <Tag color="#C0392B">Rejected</Tag>
                )}
                &nbsp;
                <i>{this.state.viewData.library_remarks}</i>
              </Descriptions.Item>
              {this.state.viewData.library_status == 1 && (
                <Descriptions.Item label="Library Verified On">
                  {this.state.viewData.library_verification_on} by{" "}
                  <strong>{this.state.viewData.library_verification_by}</strong>
                </Descriptions.Item>
              )}


              
            </Descriptions>
            
             
            
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.onViewCancel()} color="primary">
              Close
            </Button>
         
          </DialogActions>
        </Dialog>
      )}
      </div>
    );
  }
}
